<mat-form-field #formFieldContainer class="sc-drop-downdown-label" [ngStyle]="{'width':componentDefinition?.fullWidth ? '100%' : ''}">
  <mat-label #labelContainer  (click)="toggleTooltip(tooltip)">{{componentDefinition.label}}</mat-label>
  <div class="labelToolTipContainer"
       #tooltip="matTooltip"
       matTooltip="{{componentDefinition.label}}"
       [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)"
  ></div>

  <mat-select [id]="componentDefinition?.name"
              *ngIf="isMultiple"
              [formControl]="formControl"
              multiple
              [required]="isMandatory()"
              (selectionChange)='getItemFromParent($event.value)'>
    <mat-option *ngFor="let option of itemList; trackBy: trackByFn" [value]="option">
      {{option}}
    </mat-option>
  </mat-select>

  <mat-select [id]="componentDefinition?.name"
              *ngIf="!isMultiple"
              [formControl]="formControl"
              [required]="isMandatory()"
              (selectionChange)='getItemFromParent($event.value)'>
    <mat-option *ngFor="let option of itemList; trackBy: trackByFn" [value]="option">
      {{option}}
    </mat-option>
  </mat-select>
  
</mat-form-field>
